/**
 * Zero-based
 * E.g. `countTo` with a value of 5 will give `[0, 1, 2, 3, 4]`
 *
 * @param {number} countTo
 */
const repeatIndex = (countTo: number) => {
    const absoluteCount = Math.abs(Math.round(countTo));
    const direction = countTo < 0 ? -1 : 1;

    return Array(absoluteCount)
        .fill(0)
        .map((_, index) => index * direction);
};
/**
 * E.g. `countTo` with a value of 5 will give `[0, 1, 2, 3, 4, 5]`
 * E.g. `countTo` with a value of 1 and `step` value of 0.1 will give `[0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1]`
 *
 * @param {number} countTo
 */
const repeatCount = (options: {
    countTo: number;
    countFrom?: number;
    step?: number;
}) => {
    const step = options.step ?? 1;
    const countFrom = options.countFrom ?? 0;
    const countTo = options.countTo;

    if (step > 0 && countTo < countFrom)
        throw new Error("CountTo cannot be smaller than CountFrom");
    if (step < 0 && countFrom < countTo)
        throw new Error("CountFrom cannot be smaller than CountTo");

    const values: number[] = [];
    for (let value = countFrom; value <= countTo; value += step) {
        values.push(value);
    }

    return values;
};

/**
 * E.g. `from` value of 5 and `to` value of 8 will give `[5, 6, 7, 8]`
 *
 * @param {number} from
 * @param {number} to
 */
const repeatIndexFromAndTo = (from: number, to: number) =>
    repeatIndex(to - from + 1).map(item => item + from);

/** E.g. repeat(hello, 4) will return four hellos; `[hello, hello, hello, hello]` */
const repeat = <T>(item: T, count: number): T[] =>
    repeatIndex(count).map(_ => item);

export { repeat, repeatCount, repeatIndex, repeatIndexFromAndTo };
